import {useQuery} from '@tanstack/react-query'
import {QUERY_KEYS} from './keys'
import {representativeHostsV3} from '../services/representative.http'

export const useGetRepresentativeHostsV3 = (enabled = true) => {
    return useQuery({
        queryKey: [QUERY_KEYS.representativeHostsV3],
        queryFn: () => representativeHostsV3(),
        enabled
    })
}
